import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitAddInvestorToDeal } from 'components/views/FounderDeal/_helpers/founderDeal.events';
import { PIPELINE_STATUS_OPTIONS } from 'constants/globalConstants';
import { $form, $view } from 'signals/global.signals';

const FounderDealAddPipelineModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'deal-add-investor'}
    onHide={handleHideModal}
    centered
    title={`Add Investor to ${$form.value?.dealName}`}
    onPrimaryClick={handleSubmitAddInvestorToDeal}
    primaryButtonText="Add Investor"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <UniversalInput
      type="select"
      options={$view.value.investorOptions || []}
      name="investorId"
      label="Select Investor"
    />
    <div className="mb-16"><small className="text-gray-300">Note: Do not see your investor? <a href="/founder/investors" className="text-info">Click here</a> to add them.</small></div>
    <UniversalInput
      type="select"
      name="pipelineStatus"
      label="Pipeline Status"
      options={PIPELINE_STATUS_OPTIONS}
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="amountInvested"
      label="Amount already invested in this deal"
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="previouslyCommitted"
      label="Amount committed to this deal"
      className="mb-16"
    />
  </SimpleModal>
);

export default FounderDealAddPipelineModal;
